import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField} from "./components/CardField";
import {formatDateTime} from "../../../../../../utils/dateTimeUtil";
import {ReservedVehicleChatEventDTO, SupportedTimezone} from "../../../../../../api/generated";
import {getCurrencyTitle} from "../../../../../../utils/enumValueTitleUtil";

interface ReservationChatEventCardProps {
    reservedVehicleChatEvent: ReservedVehicleChatEventDTO
    timezone?: SupportedTimezone
}

export const ReservationChatEventCard: React.FC<ReservationChatEventCardProps> = ({
                                                                                      reservedVehicleChatEvent,
                                                                                      timezone
                                                                                  }) => {
    const {date, time} = formatDateTime(reservedVehicleChatEvent.reserved_at, timezone)
    return <PrimaryCollapsibleSection title={"Reservation"}>
        <CardField
            title="VIN"
            value={reservedVehicleChatEvent.stock_vehicle_vin}
        />
        <CardField
            title="VRM"
            value={reservedVehicleChatEvent.stock_vehicle_vrm}
        />
        <CardField
            title="Deposit Amount"
            value={`${getCurrencyTitle(reservedVehicleChatEvent.currency)}${reservedVehicleChatEvent.deposit_amount}`}
        />
        <CardField
            title="Date/Time"
            value={`${date} at ${time}`}
        />
    </PrimaryCollapsibleSection>
}
